import React from "react";
import { FadeInView } from "~/native-ui/AnimatedView";
import { DrawerAnimationContext} from "./DrawerAnimationContext";
import { withResponsiveFlags } from '~/hoc/withResponsiveProps';
import { Platform } from 'react-native';

export const FadeInWithDrawerView = withResponsiveFlags(({isSmallScreen, ...props}) => {
    isSmallScreen = Platform.OS !== 'web' || isSmallScreen
    
    const animation = React.useContext(DrawerAnimationContext);

    const animatedViewProps = {
        ...props,
        animation,
    }

    if (isSmallScreen) return <>{props.children}</>

    return <FadeInView {...animatedViewProps} />
}, { includeKeys: ['isSmallScreen'] })
